import { Skeleton as AntSkeleton } from "antd";
import styles from "./skeleton.module.scss";

export const Skeleton = ({ className, ...props }) => (
  <AntSkeleton active title={false} className={styles.skeleton} {...props} />
);
